export class InvalidSchemaError extends Error {
    public details: unknown;

    constructor(message: string, details?: unknown) {
        super(message);
        this.name = 'InvalidSchemaError';
        this.details = details;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, InvalidSchemaError);
        }
    }
}
